export default __webpack_public_path__ + "static/media/Background-Eclipse-Introduction.fffb2d54.svg";